import React from 'react';
import { Package } from 'lucide-react';

const Legend: React.FC = () => {
  return (
    <div className="flex flex-wrap items-center gap-4 text-sm">
      <div className="flex items-center">
        <div className="h-3 w-3 rounded-sm bg-blue-100 border border-blue-300 mr-1"></div>
        <span>Aktuelle Kurse</span>
      </div>
      <div className="flex items-center">
        <div className="h-3 w-3 rounded-sm bg-purple-100 border border-purple-300 mr-1"></div>
        <span>Zukünftige Kurse</span>
      </div>
      <div className="flex items-center">
        <div className="h-3 w-3 rounded-sm bg-green-100 border border-green-300 mr-1"></div>
        <span>Probestunden</span>
      </div>
      <div className="flex items-center">
        <Package className="h-4 w-4 text-green-600 mr-1" />
        <span>Ausreichend Kontingent</span>
      </div>
      <div className="flex items-center">
        <Package className="h-4 w-4 text-yellow-600 mr-1" />
        <span>Mittleres Kontingent</span>
      </div>
      <div className="flex items-center">
        <Package className="h-4 w-4 text-red-600 mr-1" />
        <span>Niedriges Kontingent</span>
      </div>
      <div className="flex items-center opacity-50">
        <div className="h-3 w-3 rounded-sm bg-blue-100 border border-blue-300 mr-1"></div>
        <span>Abgelaufenes Kontingent</span>
      </div>
    </div>
  );
};

export default Legend;


